export default function replacelass(
  el: HTMLElement | undefined,
  classname: string,
  replacewith: string
) {
  if (el) {
    let attr = el.getAttribute("class")
    if (attr && attr.includes(classname)) {
      attr = attr.replace(classname, replacewith)
      el.setAttribute("class", attr)
    } else {
      replacewith ? el.classList.add(replacewith) : ``
    }
  }
}
